import { StartBaseMusicSoft, StartBaseMusicSofter } from 'commands/music';
import WheelBonusRecord from 'integration/records/wheel-bonus-record';
import { MoveLayerBehind } from 'model/move-layer-behind';
import { MoveLayerInFront } from 'model/move-layer-in-front';
import { Emitter } from 'pixi-particles';
import * as PIXI from 'pixi.js';
import Components from 'slotworks/components/components';
import { BounceZoomIn, BounceZoomOut } from 'slotworks/graphics/animation/base-animations';
import canvasManager, { Orientation } from 'slotworks/graphics/canvas/canvas-manager';
import Layers from "slotworks/graphics/layers/layers";
import ExtendedSpine from 'slotworks/graphics/spine/spine';
import currency from 'slotworks/i18n/currency';
import gameState from 'slotworks/model/game-state';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from "slotworks/utils/contract";
import deviceInfo from 'slotworks/utils/device-info';
import { parallel, sequence } from 'slotworks/utils/race-utils';
import Timer from 'slotworks/utils/timer';
import { CreateParticleToContainer } from 'util/create-particle';
import SpineEmitter from 'util/spine-emitter';
import RevolverWinTransitions from './revolver-win-transitions';

/*
epic/Win_epic_in
epic/Win_epic_out
epic/Win_epic_idle
*/
const ANIMATIONS = [
    "big/Win_Big_in",
    "mega/Win_Big_Mega_in",
    "super/Win_Big_Super_in",
    "lockStock/Win_lockStock_in"
];

const ANIMATIONS_OUT = [
    "big/Win_Big_out",
    "mega/Win_Big_Mega_out",
    "super/Win_Big_Super_out",
    "lockStock/Win_lockStock_out"
];

const ANIMATIONS_IDLE = [
    "big/Win_Big_idle",
    "mega/Win_Big_Mega_idle",
    "super/Win_Big_Super_idle",
    "lockStock/Win_lockStock_idle"
]

const MUSIC = [
    "big_win",
    "mega_win",
    "super_win",
    "epic_win",
]
export default class BigWinsTransitions extends RevolverWinTransitions {

    private spine: ExtendedSpine;

    private level: number = 1;

    private onResolve: () => void;
    private full: boolean = false;
    private exiting: boolean = false;

    protected particles: Map<string, SpineEmitter> = new Map();

    protected value: PIXI.Text;

    // button_space_in, button_space_hold
    // lockStock/Win_lockStock_idle

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.exiting = false;
            Layers.BetBar.hide();
            Layers.SmartButton.hide();

            MoveLayerBehind(Layers.Custom.get("Harley"), Layers.CelebrationBackground);

            this.onResolve = resolve;
            this.clearTimers();
            this.spine = Layers.CelebrationForeground.getSpine("bigwins");
            this.spine.setSkin("win");
            // @ts-ignore
            this.spine.interactive = true;

            this.level = this.getWinLevel();

            this.full = false;
           
            if (!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(this.onLayoutChange);
            }

            Components.bigWin.totalReached.addOnce(this.onFull);

            Components.bigWin.onSkip.addOnce(this.bigWinSkip);

            const animation = ANIMATIONS[this.level - 1];
            const music = MUSIC[this.level - 1];

            const complete = () => {
                if (this.onResolve) {
                    this.onResolve();
                    this.onResolve = null;
                }
            }
            this.timers.push(Timer.setTimeout(() => {
                soundManager.customEvent(music);
                if (!deviceInfo.isDesktop) {
                    this.fixPortrait();
                }
                this.play(1, animation).then(() => {
                    complete();
                    const animationIdle = ANIMATIONS_IDLE[this.level - 1];
                    if(animationIdle && !this.exiting) {
                        this.spine.play(1, animationIdle, true);
                    }
                });

                try {
                    this.value = Layers.CelebrationForeground.getText("value");
                    this.value.updateText(true);
                    // @ts-ignore
                    this.spine.hackTextureBySlotName("placeholder_NUMERALS", PIXI.Texture.EMPTY, { width: 1, height: 1 });
        
                    const container = this.spine.slotContainers[this.spine.skeleton.findSlotIndex("NUMERALS")];
                    
                    // @ts-ignore
                    container.addChild(this.value);
                    this.value.scale.y *= -1;
                    this.value.y = 0//-180;
                } catch(e) {
                    
                }
            }, 10));
        });
    }

    private onLayoutChange = () => {
        setTimeout(this.fixPortrait, 10);
    }

    private fixPortrait = () => {
        if(canvasManager.orientation === Orientation.PORTRAIT) {
            this.spine.play(8, "portrait", true);
        } else {
            this.spine.state.setEmptyAnimation(8, 0);
        }
    }

    private bigWinSkip = () => {
        this.skipIn();
    }

    private play(slot: number, anim: string) {
        return new Contract(resolve => {
            const onSpineEvent = (n: string) => this.onSpineEvent(n);
            if (!this.spine)
                return;
            this.spine.play(slot, anim, false);
            this.spine.state.tracks[slot].listener = {
                event: function (entry, event) {
                    onSpineEvent(event.data?.name);
                },
                complete: (trackEntry) => {
                    this.spine.state.tracks[slot].listener = null;
                    // this.spine.state.clearListeners();
                    resolve(null);
                }
            }
        });
    }

    private onSpineEvent(event: string) {       
        const particle = this.getParticle(event);
    }

    private getParticle(name: string): SpineEmitter {
        let particle = this.particles.get(name);
        if (!particle) {
            let emitterName;
            let placeholder;
            if (name === "HQ_emitter_winSeq_coins") {
                emitterName = "HQ_emitter_winSeq_coins";
                placeholder = "particle/placeholder_HQ_particle_coin";
            } else if (name === "HQ_emitter_winSeq_rhombus") {
                emitterName = "HQ_emitter_winSeq_rhombus";
                placeholder = "particle/placeholder_HQ_particle_rhombus";
            } else if (name === "HQ_emitter_winSeq_splash_coin") {
                emitterName = "HQ_emitter_winSeq_splash_coin";
                placeholder = "particle/placeholder_HQ_particle_coin2";
            } else if (name === "HQ_emitter_winSeq_splash_rhombus") {
                emitterName = "HQ_emitter_winSeq_splash_rhombus";
                placeholder = "particle/placeholder_HQ_particle_rhombus2";
            } else if (name === "HQ_emitter_cluster") {
                emitterName = "HQ_emitter_cluster";
                placeholder = "particle/placeholder_HQ_particle_cluster_01";
            } else if (name === "HQ_emitter_cluster_splash") {
                emitterName = "HQ_emitter_cluster_splash";
                placeholder = "particle/placeholder_HQ_particle_cluster_02";
            }
            // HQ_emitter_cluster
            // HQ_emitter_cluster_splash

            if (emitterName) {
                const particleContainer = new PIXI.Container();
                const emitter = CreateParticleToContainer(emitterName, emitterName, particleContainer);

                particle = {
                    particle: emitter,
                    container: particleContainer
                }
                this.particles.set(name, particle);
                const container = this.spine.slotContainers[this.spine.skeleton.findSlotIndex(placeholder)] as PIXI.Container;
                container.addChild(particleContainer);

                particleContainer.scale.y *= -1;
                particle.particle.emit = true;
            }
        } else {
            particle.particle.emit = !particle.particle.emit;
        }
        return particle;
    }

    public skipIn() {        
        Components.bigWin.onSkip.remove(this.bigWinSkip);
        if (!this.full) {
            this.clearTimers();

            if (this.onResolve) {
                this.onResolve();
                this.onResolve = null;
            }
            let winnings;
            const record = gameState.getCurrentGame().getCurrentRecord();
            if (record instanceof WheelBonusRecord) {
                winnings = record.totalCreditsWon;
            } else if (gameState.getCurrentGame().getCurrentRecord().beenPaid) {
                winnings = gameState.getCurrentGame().totalCreditsWon;
            } else {
                winnings = gameState.getCurrentGame().getCurrentRecord().creditsWon;
            }
            this.value.text = currency.format(winnings, undefined, undefined, true);;
            this.onFull();
            
            const animationIdle = ANIMATIONS_IDLE[this.level - 1];
            if(animationIdle && !this.exiting) {
                this.spine.play(1, animationIdle, true);
                // this.spine.play(0, "particle_idle_loop", true); // 
            }

            Components.bigWin.totalReached.removeAll();
        }
        this.exiting = true;
    }

    public out(): Contract<void> {
        this.full = true;
        this.exiting = true;
        StartBaseMusicSofter();
        const animation = ANIMATIONS_OUT[this.level - 1];
        deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        Components.bigWin.totalReached.removeAll();
        Components.bigWin.onSkip.remove(this.bigWinSkip);
        soundManager.customEvent("plaque_exit");       
        return sequence([
            () => this.play(1, animation),
            () => Contract.wrap(() => {
                this.stopParticles();
            }),
            () => Contract.getTimeoutContract(1000),
            () => Contract.wrap(() => {
                this.clean();
                this.clearParticles();
                Layers.BetBar.show();
                Layers.SmartButton.show();
                StartBaseMusicSoft(true);
                Layers.Custom.get("Harley").moveBehind(Layers.Custom.get("Transition"));
            }),
            () => Contract.getTimeoutContract(100),
        ]);
    }

    public destroy() {
        this.clearTimers();        
    }

    private onFull = () => {
        if (!this.full) {
            setTimeout(() => {
                if(!this.exiting) StartBaseMusicSofter();
            }, 1300);
        }
        this.full = true;
    }

    protected clearTimers() {
        if (this.timers) {
            for (const timer of this.timers) {
                Timer.clearTimeout(timer);
            }
            this.timers = [];
        }
    }

    protected stopParticles() {
        for (let [key, particle] of this.particles) {
            particle.particle.emit = false;
        }
    }

    private clearParticles() {
        for (let [key, particle] of this.particles) {
            particle.particle.emit = false;
            particle.container.parent.removeChild(particle.container);
            particle.particle.destroy();
            particle.container = null;
            particle.particle = null;
        }
        this.particles.clear();
    }

    private clean() {
        this.spine.state.clearTracks();
        this.spine.state.clearListeners();
        this.spine.state.update(1);
        this.spine.skeleton.setToSetupPose();
        this.clearTimers();
        Components.bigWin.totalReached.removeAll();
    }

}